import {Antworttyp} from "../api";

// Enum-like object for type-safe comparisons
export const AntwortTyp = {
    BOOLEAN: 'Boolean' as Antworttyp,
    INT: 'Int' as Antworttyp,
    DOUBLE: 'Double' as Antworttyp,
    STRING: 'String' as Antworttyp,
} as const;

export const ANTWORTTYPEN: Antworttyp[] = [
    AntwortTyp.BOOLEAN,
    AntwortTyp.INT,
    AntwortTyp.DOUBLE,
    AntwortTyp.STRING,
];